import React, { useEffect, useState } from "react";
import {
  MwButton,
  MwInputText,
  MwSpinner,
  MwSpinnerButton,
  MwSwitch,
  MwTextArea,
} from "../../../components/ui";
import { usePost, useCurrent, usePut, useFetch } from "../../../hooks";
import { FaTimes } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import CardHeadeWithActions from "../../../components/ui/CardHeadeWithActions";

const WarehouseForm = ({
  warehouseFormState,
  setWarehouseFormState,
  mode,
  onCancel,
  setShowForm,
  setIsAdded,
  warehouseId,
}) => {
  const [t] = useTranslation("global");
  const { currentTenantId, currentCompanyId, currentBranchId, userId } =
    useCurrent();
  const [isLoading, setIsLoading] = useState(true);
  const [isDataReady, setIsDataReady] = useState(false);
  const [nameArError, setNameArError] = useState(false);

  const RequisitionsNumber =
    mode === "add"
      ? `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/gen-code/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null;

  const { data: NumberData } = useFetch(RequisitionsNumber);
  const {
    data: postDataResult,
    loading: postLoading,
    postData,
    error,
  } = usePost();
  const { data: putData, loading: putLoading, putData: updateData } = usePut();
  const { data: warehouseData, loading: warehouseLoading } = useFetch(
    mode === "edit"
      ? `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${warehouseId}`
      : null,
  );

  // Handle initial loading state
  useEffect(() => {
    setIsLoading(true);
    setIsDataReady(false);

    const timer = setTimeout(() => {
      if (mode === "add") {
        if (NumberData?.data) {
          setWarehouseFormState({
            code: NumberData.data,
            name_ar: "",
            name_en: "",
            address: "",
            is_active: false,
          });
          setIsDataReady(true);
        }
      } else if (mode === "edit" && warehouseData?.data) {
        setWarehouseFormState({
          code: warehouseData.data.code || "",
          name_ar: warehouseData.data.name_ar || "",
          name_en: warehouseData.data.name_en || "",
          address: warehouseData.data.address || "",
          is_active: Boolean(warehouseData.data.is_active),
        });
        setIsDataReady(true);
      }
    }, 300); // تأخير لتجميع البيانات

    return () => clearTimeout(timer);
  }, [mode, NumberData, warehouseData]);

  // Handle loading state transition
  useEffect(() => {
    if (isDataReady) {
      const loadingTimer = setTimeout(() => {
        setIsLoading(false);
      }, 500); // تأخير إضافي قبل إظهار النموذج

      return () => clearTimeout(loadingTimer);
    }
  }, [isDataReady]);

  const handleCancel = () => {
    setShowForm(false);
    setWarehouseFormState({
      code: "",
      name_ar: "",
      name_en: "",
      address: "",
      is_active: false,
    });
  };

  const submitHandler = () => {
    if (
      !warehouseFormState.name_ar ||
      warehouseFormState.name_ar.trim() === ""
    ) {
      setNameArError(true);
      toast(t("requisition.warehouse_name_ar_required"), {
        type: "error",
        autoClose: 2000,
        theme: "colored",
      });
      return;
    }
    setNameArError(false);

    const _data = {
      ...warehouseFormState,
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
      created_by: userId,
    };

    if (mode === "add") {
      postData(
        `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses`,
        _data,
      );
    } else if (mode === "edit") {
      updateData(
        `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${warehouseId}`,
        _data,
      );
    }
  };
  console.log("error", error, "postDataResult", postDataResult);
  useEffect(() => {
    if (postDataResult || putData) {
      const isSuccess = postDataResult?.status === 1 || putData?.status === 1;

      const message = isSuccess
        ? mode === "edit"
          ? t("requisition.warehouse_updated_successfully")
          : t("requisition.warehouse_added_successfully")
        : t("requisition.error_occurred");

      toast(message, {
        type: isSuccess ? "success" : "error",
        autoClose: 1500,
        theme: "colored",
      });

      if (isSuccess) {
        setTimeout(() => {
          setIsAdded(true);
          onCancel();
        }, 1500);
      }
    }
  }, [postDataResult, putData]);

  useEffect(() => {
    if (error) {
      if (error.message?.includes("exists")) {
        toast.error(t("requisition.duplicate_number"), {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
      } else {
        toast.error(
          error.response?.data?.message ||
            error.message ||
            t("deleted.error_fetching_data"),
          {
            position: "top-center",
            autoClose: 3000,
            theme: "colored",
          },
        );
      }
    }
  }, [error]);

  // تحسين شكل شاشة التحميل
  if (isLoading) {
    return (
      <div className="rounded-xl bg-slate-100 p-5 my-4">
        <div className="flex flex-col items-center justify-center h-[400px]">
          <MwSpinner size="lg" />
          {/* <div className="mt-4 text-slate-500">
                        {mode === 'edit' ? t('requisition.loading_warehouse_data') : t('requisition.preparing_form')}
                    </div> */}
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ top: "90px" }}
      />

     <div className="rounded-2xl w-[98%] mx-auto bg-slate-100 p-6 my-4">
  <CardHeadeWithActions
    title={
      <div className="flex items-center justify-between w-full">
        <h2 className="text-lg font-bold text-slate-700">
          {mode === "edit"
            ? t("requisition.edit_warehouse")
            : t("requisition.add_new_warehouse")}
        </h2>
      </div>
    }
  >
    <MwButton
      size="sm"
      type="saveBtn"
      onClick={submitHandler}
      disabled={postLoading || putLoading}
    >
      {mode === "edit"
        ? t("requisition.update")
        : t("requisition.save")}
    </MwButton>
  </CardHeadeWithActions>

  <div className="grid grid-cols-12  gap-5 mt-6">

    {/* Code */}
    <div className="col-span-12  md:col-span-4">
      <MwInputText
        label={t("requisition.warehouse_code")}
        placeholder={t("requisition.auto_generated")}
        value={warehouseFormState.code}
        onChange={(e) =>
          setWarehouseFormState({
            ...warehouseFormState,
            code: e.target.value,
          })
        }
        disabled={mode === "edit"}
      />
    </div>

    {/* Arabic Name */}
    <div className="col-span-12 md:col-span-4">
      <MwInputText
        label={t("requisition.warehouse_name_ar")}
        value={warehouseFormState.name_ar}
        placeholder={t("requisition.warehouse_name_ar")}
        onChange={(e) =>
          setWarehouseFormState({
            ...warehouseFormState,
            name_ar: e.target.value,
          })
        }
      />

      {nameArError && (
        <div className="text-red-500 text-sm mt-1">
          هذا الحقل مطلوب
        </div>
      )}
    </div>

    {/* English Name */}
    <div className="col-span-12 md:col-span-4">
      <MwInputText
        label={t("requisition.warehouse_name_en")}
        placeholder={t("requisition.warehouse_name_en")}
        value={warehouseFormState.name_en}
        onChange={(e) =>
          setWarehouseFormState({
            ...warehouseFormState,
            name_en: e.target.value,
          })
        }
      />
    </div>

    {/* Address */}
    <div className="col-span-12 md:col-span-9">
      <MwTextArea
        label={t("requisition.warehouse_title")}
        placeholder={t("requisition.warehouse_title")}
        value={warehouseFormState.address}
        onChange={(e) =>
          setWarehouseFormState({
            ...warehouseFormState,
            address: e.target.value,
          })
        }
      />
    </div>

    {/* Status */}
    <div className=" mt-7 col-span-12 md:col-span-3 justify-center items-center">
      <div className="bg-white border rounded-2xl p-3 flex items-center justify-between shadow-sm">
        <div>
          <div className="font-bold text-sm text-slate-700">
            {t("requisition.active")}
          </div>

          <div className="text-xs text-slate-400 mt-1">
            حالة المستودع
          </div>
        </div>

        <MwSwitch
          isActive={warehouseFormState.is_active}
          setIsActive={(newValue) =>
            setWarehouseFormState({
              ...warehouseFormState,
              is_active: newValue,
            })
          }
          onChangeSwitch={() =>
            setWarehouseFormState({
              ...warehouseFormState,
              is_active: !warehouseFormState.is_active,
            })
          }
        />
      </div>
    </div>
  </div>
</div>
    </>
  );
};

export default WarehouseForm;
